import API from "../API";

export const getDeliveryAddressesApi = async () => {
  try {
    const response = await API.get(`/delivery-address`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleDeliveryAddressApi = async (deliveryAddressId) => {
  try {
    const response = await API.get(`/delivery-address/${deliveryAddressId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postSingleDeliveryAddressApi = async (payload) => {
  try {
    const response = await API.post(`/delivery-address`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSingleDeliveryAddressApi = async (payload) => {
  try {
    const response = await API.put(`/delivery-address`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteSingleDeliveryAddressApi = async (deliveryAddressId) => {
  try {
    const response = await API.delete(
      `/delivery-address?deliveryAddressId=${deliveryAddressId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const setDefaultDeliveryAddressApi = async (deliveryAddressId) => {
  try {
    const response = await API.put(`/delivery-address/${deliveryAddressId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
